import React from "react";
import "./RowCardShadow.css";
import { Col, Row } from "reactstrap";
import { isMobile } from "../../../utils/deviceInfo";

export function LayoutHeadingShadow({
  children,
  colWidth,
  className,
  colWidthMobile,
}) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={`py-2  ${className} text-center trivia-table-heading-small LayoutHeadingShadow`}
    >
      {children}
    </Col>
  );
}
export function LayoutHeadingShadowLeft({
  children,
  colWidth,
  className,
  colWidthMobile,
}) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={`py-2  ${className} text-left `}
    >
      {children}
    </Col>
  );
}

export function LayoutRowShadow({
  children,
  className,
  onMouseLeave=()=>{},
  onMouseEnter=()=>{},
  onClick=()=>{},
  draggable,
  onDragStart,
  onDragEnd,
  onDragEnter,
  onDragOver,
  onDragLeave,
  onDrop
}) {
  return (
    <Row
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`${className} layout-row-shadow`}
      onClick={onClick}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      {children}
    </Row>
  );
}

export function LayoutDataLines({
  children,
  colWidth,
  className,
  colWidthMobile,
  noFlex
}) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={`action-table-data border border-grey px-2 ${
        isMobile ? "py-2" : "py-2"
      } ${className} `}
    >
      {
        noFlex ? children :<div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height:"100%"
        }}
      >
        {children}
      </div>
      }
      
    </Col>
  );
}

export function LayoutData({ children, colWidth, className, colWidthMobile }) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={`action-table-data ${className} px-2`}
    >
      {children}
    </Col>
  );
}

export function LayoutHeadingLines({
  children,
  colWidth,
  className,
  colWidthMobile,
  plainTable,
}) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={
        plainTable
          ? "plain-table-action-heading"
          : `action-heading ${className} cursor-pointer`
      }
    >
      {children}
    </Col>
  );
}

export function LayoutRowLines({
  children,
  className,
  plainTable,
  style,
  noHeight,
}) {
  return (
    <Row
      style={{ ...style }}
      className={`${className} ${!noHeight && "planning-row-mobile-height"}`}
    >
      {children}
    </Row>
  );
}
